$(function() {

    // Initialize the first tab as active
    $("#tabs-nav li:first-child").addClass("active");
    $(".tab-content").hide();
    $(".tab-content:first").addClass("blinix-active").show();

    // Blinix product tabs slider initialization
    $('.blinix-tabs-collection-section .blinix-active .blinix-product-warpper').slick({
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: true,
                dots: false,
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }]
    });

    // Event handler for tab click
    $("#tabs-nav li").click(function() {
        // Destroy the existing slider
        $('.blinix-tabs-collection-section .blinix-active .blinix-product-warpper').slick("destroy");

        // Delay and reinitialize the slider to avoid issues
        setTimeout(function() {
            $('.blinix-tabs-collection-section .blinix-active .blinix-product-warpper').slick({
                arrows: true,
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        dots: false,
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            });
        }, 100);
    });

    // Event handler for tab click (change tab and display content)
    $("#tabs-nav li").click(function() {
        // Update tab and content visibility
        $("#tabs-nav li").removeClass("active");
        $(this).addClass("active");
        $(".tab-content").removeClass("blinix-active").hide();

        // Show the content of the clicked tab
        var activeTab = $(this).find("a").attr("href");
        $(activeTab).fadeIn().addClass("blinix-active");

        return false;
    });


  // image- gallery 

 // image slider
  $(".fancybox").fancybox();
    $(".my-slide-wrapper").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        responsive: [{
            breakpoint: 768,
            settings: {
                centerMode: true,
                centerPadding: '30px',
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });


  // $(".list-menu.list-menu--inline li:nth(1) a").append(`<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>`);
  $("#HeaderMenu-shop-all , #mega-menu1 .blinix-megamenu-wrapper").hover(
        function() {
             $(".blinix-megamenu#mega-menu1").css("display", "block");
        },
        function() {
            setTimeout(function() {}, 2000);
            $(".blinix-megamenu").css("display", "none");
        }
    );

    $("#HeaderMenu-best-sellers ,#mega-menu2 .blinix-megamenu-wrapper").hover(
        function() {
             $(".blinix-megamenu#mega-menu2").css("display", "block");
        },
        function() {
            setTimeout(function() {}, 2000);
            $("#mega-menu2").css("display", "none");
        }
    );

 
 
  



// Footer
// Attach click event listener outside of toggleAccordion function
$(".blinix-toggle").click(function () {
    if ($(window).width() < 750) {
        // Toggle active class
        $(this).toggleClass("active");
        // Toggle accordion content
        $(this).next("ul.footer-block__details-content").slideToggle();
        // Close other accordions
        $(".blinix-toggle").not(this).removeClass("active");
        $("ul.footer-block__details-content").not($(this).next("ul.footer-block__details-content")).slideUp();
    }
});

// Define toggleAccordion function
function toggleAccordion() {
    if ($(window).width() >= 750) {
        // Remove click event listener when window size is greater than or equal to 750px
        $(".blinix-toggle").off("click");
        $("ul.footer-block__details-content").removeAttr("style"); // Remove inline style for accordion content
    }
}

// Initial call to toggleAccordion function after a delay of 2 seconds
setTimeout(function() {
    toggleAccordion();
}, 2000);

// Call toggleAccordion function on window resize
$(window).resize(function () {
    toggleAccordion();
});

  

});







